import React from 'react';
import { motion } from 'framer-motion';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}
export function PageBanner({
  title,
  subtitle,
  backgroundImage
}: PageBannerProps) {
  return <section className="relative pt-44 pb-32 md:pt-52 md:pb-40 flex items-center justify-center overflow-hidden" data-id="element-277">
      {/* Background Image */}
      {backgroundImage && <div className="absolute inset-0" data-id="element-278">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover" data-id="element-279" />
          <div className="absolute inset-0 bg-gradient-to-t from-jet/85 via-jet/55 to-jet/30" data-id="element-280"></div>
          <div className="absolute inset-0 bg-burgundy/15 mix-blend-multiply" data-id="element-281"></div>
          <div className="absolute inset-0 backdrop-blur-[2px]" data-id="element-282"></div>
        </div>}

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-283">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-heading font-bold text-white mb-4" data-id="element-284">
          {title}
        </motion.h1>
        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-white/90 font-light" data-id="element-285">
            {subtitle}
          </motion.p>}
      </div>
    </section>;
}